"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var CalculatorContextInterface_1 = require("../../CalculatorContextInterface");
var CurrencyUtils_1 = require("../../../../../../utils/CurrencyUtils");
var SaleUtils_1 = require("../../../../../../utils/SaleUtils");
var ExchangerUtils_1 = require("../../../../../../utils/ExchangerUtils");
var CustomCurrencyCodeEnums_1 = require("../../../../../../../app/types/enum/CustomCurrencyCodeEnums");
var react_cookie_1 = require("react-cookie");
var react_hook_form_1 = require("react-hook-form");
var GamePriceList = function () {
    var TABLE_CURRENCY_VALUE = 'table-currency-value';
    var _a = (0, react_i18next_1.useTranslation)(), t = _a.t, i18n = _a.i18n;
    var _b = (0, CalculatorContextInterface_1.useCalculatorContext)(), game = _b.game, payment = _b.payment, defaultCurrency = _b.defaultCurrency, exchanger = _b.exchanger, serverDefaultList = _b.serverDefaultList
    //serverList
    ;
    var watch = (0, react_hook_form_1.useFormContext)().watch;
    var watchFraction = watch("fraction");
    var _c = (0, react_1.useState)([]), fractionObjList = _c[0], setFractionObjList = _c[1];
    var _d = (0, react_1.useState)([]), serverList = _d[0], setServerList = _d[1];
    var _e = (0, react_1.useState)([
        { currency_code: 978 },
        { currency_code: 643 },
        { currency_code: 840 },
        { currency_code: 980 },
        { currency_code: CustomCurrencyCodeEnums_1.CustomCurrencyCodeEnums.BINANCE_USDT_CODE }
    ]), paymentList = _e[0], setPaymentList = _e[1];
    //const [paymentListCode, setPaymentListCode] = useState<number[]>([978, 643, 840,980]);
    var _g = (0, react_1.useState)(), localPayment = _g[0], setLocalPayment = _g[1];
    var _h = (0, react_cookie_1.useCookies)([TABLE_CURRENCY_VALUE]), cookies = _h[0], setCookie = _h[1];
    var _j = (0, react_1.useState)(), selectedFraction = _j[0], setSelectedFraction = _j[1];
    (0, react_1.useEffect)(function () {
        if (game && game.id) {
            axios_1.default.get("/app/game/".concat(game.id, "/server"))
                .then(function (response) {
                if (response.status == 200) {
                    setServerList(response.data);
                    if (game.fraction.length) {
                        setSelectedFraction(game.fraction[0]);
                    }
                }
            }).catch(function (error) {
                console.log("error", error);
            });
            setFractionObjList(game.fraction);
        }
    }, [game]);
    (0, react_1.useEffect)(function () {
        setServerList(function (_list) { return _list.map(function (_item) {
            var price = _item.fraction_price.find(function (_f) { return _f.fraction_id == (selectedFraction === null || selectedFraction === void 0 ? void 0 : selectedFraction.fraction_id); });
            if (price) {
                return __assign(__assign({}, _item), { default_price: price.price });
            }
            else {
                var _ds = serverDefaultList === null || serverDefaultList === void 0 ? void 0 : serverDefaultList.find(function (_i) { return _i.id == _item.id; });
                return _ds ? _ds : _item;
            }
        }); });
    }, [selectedFraction]);
    (0, react_1.useEffect)(function () {
        if (cookies[TABLE_CURRENCY_VALUE] !== undefined) {
            var code = cookies[TABLE_CURRENCY_VALUE];
            setLocalPayment(paymentList.find(function (_i) { return _i.currency_code == code; }));
        }
    }, [cookies]);
    (0, react_1.useEffect)(function () {
        /*
        axios.get<Payment[]>("/app/payment")
            .then((response) => {

                let pl = [] as Payment[];
                response.data?.map(item => {
                    let find = pl.find(x => x.currency_code === item.currency_code);

                    if (!find) {
                        console.log(item);
                        pl.push(item);
                    }
                });
                setPaymentList(pl);
            });
        */
        //console.log("defaultCurrency",defaultCurrency);
    }, []);
    (0, react_1.useEffect)(function () {
        if (payment)
            setLocalPayment(payment);
    }, [payment]);
    function getPrice(defPrice, currency_code, value) {
        if (game && exchanger) {
            var countCoints = parseFloat((value / defPrice).toFixed(4)); ///value+(value/100)*SaleUtils.vd(game,value);
            var discount = countCoints * SaleUtils_1.SaleUtils.vd(game, value) / 100;
            countCoints = countCoints + discount;
            if (value == 0) {
                var _price = ((defPrice) / ExchangerUtils_1.ExchangerUtils.conver(exchanger, currency_code));
                return _price > 1 ? _price.toFixed(2) : CurrencyUtils_1.CurrencyUtils.format(_price);
            }
            var defPriceCurrency = ((value / countCoints) / ExchangerUtils_1.ExchangerUtils.conver(exchanger, currency_code));
            return defPriceCurrency > 1 ? defPriceCurrency.toFixed(2) : CurrencyUtils_1.CurrencyUtils.format(defPriceCurrency);
        }
    }
    function getPriceCaption(value, currency_code) {
        if (game && exchanger) {
            return Math.ceil(((value) / ExchangerUtils_1.ExchangerUtils.conver(exchanger, currency_code)));
        }
    }
    function handleCurrencyChange(e) {
        var _a;
        var now = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
        setCookie(TABLE_CURRENCY_VALUE, (_a = paymentList.find(function (x) { return x.currency_code == e.target.value; })) === null || _a === void 0 ? void 0 : _a.currency_code, { path: '/', expires: now });
        setLocalPayment(paymentList.find(function (x) { return x.currency_code == e.target.value; }));
    }
    var handleFractionChange = function (e) {
        setSelectedFraction(fractionObjList.find(function (_item) { return _item.fraction_id == e.target.value; }));
    };
    (0, react_1.useEffect)(function () {
        if (watchFraction) {
            setSelectedFraction(fractionObjList.find(function (_item) { return _item.fraction_id == watchFraction; }));
        }
    }, [watchFraction]);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("div", { className: "game-server-price-list" },
            react_1.default.createElement("div", { className: "__caption-wrap" },
                react_1.default.createElement("div", { className: "__caption" }, t("server.list.caption")),
                react_1.default.createElement("div", { style: {
                        display: "flex",
                        gap: "32px"
                    }, className: "" },
                    react_1.default.createElement("div", null, fractionObjList.length > 0 &&
                        react_1.default.createElement("select", { value: selectedFraction === null || selectedFraction === void 0 ? void 0 : selectedFraction.fraction_id, onChange: handleFractionChange, style: { marginTop: "0", minWidth: "180px" } }, fractionObjList.map(function (item, index) {
                            return react_1.default.createElement("option", { selected: index == 0, 
                                //selected={sale?.server_id == item.id}
                                key: item.fraction_id, value: item.fraction_id }, t(item.caption));
                        }))),
                    react_1.default.createElement("div", null, paymentList.length > 0 ?
                        react_1.default.createElement("select", { defaultValue: defaultCurrency, value: localPayment === null || localPayment === void 0 ? void 0 : localPayment.currency_code, onChange: handleCurrencyChange, style: { marginTop: "0", minWidth: "120px" } }, paymentList.map(function (item) {
                            return react_1.default.createElement("option", { 
                                //selected={sale?.server_id == item.id}
                                key: item.currency_code, value: item.currency_code }, CurrencyUtils_1.CurrencyUtils.symbol(item.currency_code));
                        }))
                        : ''))),
            react_1.default.createElement("div", { className: "__caption-price-list" },
                react_1.default.createElement("span", { className: "__title-name" },
                    t("server.list.caption_1"),
                    " "),
                react_1.default.createElement("span", null,
                    t("server.list.caption_2"),
                    " 0 ",
                    CurrencyUtils_1.CurrencyUtils.symbol(localPayment ? localPayment.currency_code : defaultCurrency)),
                react_1.default.createElement("span", null,
                    t("server.list.caption_2"),
                    " ",
                    getPriceCaption(SaleUtils_1.SALE_DISCOUNT_VALUE_1, localPayment ? localPayment.currency_code : defaultCurrency),
                    " ",
                    CurrencyUtils_1.CurrencyUtils.symbol(localPayment ? localPayment.currency_code : defaultCurrency)),
                react_1.default.createElement("span", null,
                    t("server.list.caption_2"),
                    " ",
                    getPriceCaption(SaleUtils_1.SALE_DISCOUNT_VALUE_2, localPayment ? localPayment.currency_code : defaultCurrency),
                    " ",
                    CurrencyUtils_1.CurrencyUtils.symbol(localPayment ? localPayment.currency_code : defaultCurrency)),
                react_1.default.createElement("span", null,
                    t("server.list.caption_2"),
                    " ",
                    getPriceCaption(SaleUtils_1.SALE_DISCOUNT_VALUE_3, localPayment ? localPayment.currency_code : defaultCurrency),
                    " ",
                    CurrencyUtils_1.CurrencyUtils.symbol(localPayment ? localPayment.currency_code : defaultCurrency)),
                react_1.default.createElement("span", null,
                    t("server.list.caption_3"),
                    " ",
                    getPriceCaption(SaleUtils_1.SALE_DISCOUNT_VALUE_4, localPayment ? localPayment.currency_code : defaultCurrency),
                    " ",
                    CurrencyUtils_1.CurrencyUtils.symbol(localPayment ? localPayment.currency_code : defaultCurrency))),
            react_1.default.createElement("div", { className: "__item-price-list-wrap" }, serverList === null || serverList === void 0 ? void 0 : serverList.map(function (item) {
                return react_1.default.createElement("div", { key: item.id, className: "__item-price-list" },
                    react_1.default.createElement("span", { className: "__server-name" },
                        item.app_locale_name,
                        " ",
                        selectedFraction ? "(".concat(t(selectedFraction.caption), ")") : '',
                        " "),
                    react_1.default.createElement("span", null,
                        getPrice(item.default_price, localPayment ? localPayment.currency_code : defaultCurrency, 0),
                        " ",
                        CurrencyUtils_1.CurrencyUtils.symbol(localPayment ? localPayment.currency_code : defaultCurrency)),
                    react_1.default.createElement("span", null,
                        getPrice(item.default_price, localPayment ? localPayment.currency_code : defaultCurrency, SaleUtils_1.SALE_DISCOUNT_VALUE_1),
                        " ",
                        CurrencyUtils_1.CurrencyUtils.symbol(localPayment ? localPayment.currency_code : defaultCurrency)),
                    react_1.default.createElement("span", null,
                        getPrice(item.default_price, localPayment ? localPayment.currency_code : defaultCurrency, SaleUtils_1.SALE_DISCOUNT_VALUE_2),
                        " ",
                        CurrencyUtils_1.CurrencyUtils.symbol(localPayment ? localPayment.currency_code : defaultCurrency)),
                    react_1.default.createElement("span", null,
                        getPrice(item.default_price, localPayment ? localPayment.currency_code : defaultCurrency, SaleUtils_1.SALE_DISCOUNT_VALUE_3),
                        " ",
                        CurrencyUtils_1.CurrencyUtils.symbol(localPayment ? localPayment.currency_code : defaultCurrency)),
                    react_1.default.createElement("span", null,
                        getPrice(item.default_price, localPayment ? localPayment.currency_code : defaultCurrency, SaleUtils_1.SALE_DISCOUNT_VALUE_4),
                        " ",
                        CurrencyUtils_1.CurrencyUtils.symbol(localPayment ? localPayment.currency_code : defaultCurrency)));
            })))));
};
exports.default = GamePriceList;
